import { auth_routes } from 'pages/auth/index'
import { app_routes } from 'pages/index'


const routes =
    [
        ...app_routes,
        ...auth_routes,
        // ...teachers_routes,
        // ...students_routes,
        // ...counsellor_routes

    ]
export { routes }